import Button from "@material-ui/core/Button";
import { Formik, FormikActions, FormikProps } from "formik";
import React, { PureComponent } from "react";
import * as Yup from "yup";
import NewEditProps from "../../../componentes/CRUD/crudProps";
import EditContext from "../../../componentes/CRUD/editContext";
import Loading from "../../../componentes/Loading/Loading";
import { GetDadoNFeComponent, SalvarDadosNFeProps, withSalvarDadosNFe } from "../../../graphql/components";
import FormDadosNFe from "./formDadosNFe";
import voca from "voca";
import AcoesFormulario from "../../../componentes/FloatingPanel/acoesFormulario";
import { campoObrigatorio } from "../../../utils/mensagens";

const PerfilSchema = Yup.object().shape({
  codpessoa: Yup.number().required(campoObrigatorio("Empresa")),
  codpessoaemissao: Yup.number().required(campoObrigatorio("Empresa Emissora NotaFiscal")),
  codcidade: Yup.number().required(campoObrigatorio("Cidade/Estado")),
  cnae: Yup.string(),
  subitem: Yup.string().required(campoObrigatorio("CNAE Item")),
  descsubitem: Yup.string(),
  codigotributacaomunicipio: Yup.string().required(campoObrigatorio("Cod. Trib. Município")),
  desccnae: Yup.string(),
  descservico: Yup.string(),
  pis: Yup.string(),
  cofins: Yup.string(),
  ir: Yup.string(),
  csll: Yup.string(),
  iss: Yup.string(),
  valorminimocalculoir: Yup.string(),
  valorminimocalculopiscofinscsll: Yup.string(),
  naturezaoperacao: Yup.string(),
  regimeespecialtributacao: Yup.string(),
  opatantesimplesnacional: Yup.string(),
  incentivadorcultural: Yup.string().required(campoObrigatorio("Incentivador Cultural")),
  senhacertificado: Yup.string(),
  email: Yup.string().required(campoObrigatorio("Email")),
  smtp: Yup.string().required(campoObrigatorio("SMTP")),
  porta: Yup.number().required(campoObrigatorio("Porta")),
  senhaemail: Yup.string().required(campoObrigatorio("Senha Email")),
  logo: Yup.string(),
  certificado: Yup.string()
});

export const initialValues = {
  codpessoa: (null as unknown) as number,
  codpessoaemissao: (null as unknown) as number,
  codcidade: (null as unknown) as number,
  cnae: "",
  subitem: "",
  descsubitem: "",
  codigotributacaomunicipio: "",
  desccnae: "",
  descservico: "",
  pis: "",
  cofins: "",
  ir: "",
  csll: "",
  iss: "",
  valorminimocalculoir: "",
  valorminimocalculopiscofinscsll: "",
  naturezaoperacao: "",
  regimeespecialtributacao: "",
  opatantesimplesnacional: "",
  incentivadorcultural: "",
  senhacertificado: "",
  email: "",
  smtp: "",
  porta: (null as unknown) as number,
  senhaemail: "",
  logo: "",
  certificado: ""
};

export type FormValues = typeof initialValues;

export class NewEditDadosNFe extends PureComponent<SalvarDadosNFeProps<NewEditProps>> {
  static contextType = EditContext;

  submit = async (values: FormValues, actions: FormikActions<FormValues>) => {
    try {
      const response = await this.props.mutate!({
        variables: {
          values: {
            editValues: {
              cnae: values.cnae,
              codcidade: values.codcidade,
              codigotributacaomunicipio: values.codigotributacaomunicipio,
              codpessoa: values.codpessoa,
              codpessoaemissao: values.codpessoaemissao,
              cofins: parseFloat(voca.replaceAll(voca.replaceAll(values.cofins, ".", ""), ",", ".")),
              csll: parseFloat(voca.replaceAll(voca.replaceAll(values.csll, ".", ""), ",", ".")),
              desccnae: values.desccnae,
              descservico: values.descservico,
              descsubitem: values.descsubitem,
              email: values.email,
              incentivadorcultural: values.incentivadorcultural,
              ir: parseFloat(voca.replaceAll(voca.replaceAll(values.ir, ".", ""), ",", ".")),
              iss: parseFloat(voca.replaceAll(voca.replaceAll(values.iss, ".", ""), ",", ".")),
              naturezaoperacao: values.naturezaoperacao,
              opatantesimplesnacional: values.opatantesimplesnacional,
              pis: parseFloat(voca.replaceAll(voca.replaceAll(values.pis, ".", ""), ",", ".")),
              porta: values.porta,
              regimeespecialtributacao: values.regimeespecialtributacao,
              senhacertificado: values.senhacertificado,
              senhaemail: values.senhaemail,
              smtp: values.smtp,
              subitem: values.subitem,
              valorminimocalculoir: parseFloat(voca.replaceAll(voca.replaceAll(values.valorminimocalculoir, ".", ""), ",", ".")),
              valorminimocalculopiscofinscsll: parseFloat(
                voca.replaceAll(voca.replaceAll(values.valorminimocalculopiscofinscsll, ".", ""), ",", ".")
              ),
              certificado: values.certificado,
              logo: values.logo
            },
            searchValues: {
              codpessoa: values.codpessoa
            }
          },
          insert: this.context ? false : true
        }
      });
      if (response && response.data && response.data.salvarDadosNFe) {
        actions.setSubmitting(false);
        this.props.close();
        this.props.setMessage(true, "success", "Registro salvo com sucesso!");
      }
    } catch (e) {
      actions.setSubmitting(false);
    }
  };

  render() {
    return (
      <div style={{ overflowY: "auto", height: "90%", overflowX: "hidden" }}>
        <Formik
          initialValues={initialValues}
          onSubmit={this.submit}
          validationSchema={PerfilSchema}
          render={(formikBag: FormikProps<FormValues>) => (
            <form autoComplete="new-password" role="presentation" onSubmit={formikBag.handleSubmit}>
              {!this.context && <FormDadosNFe formikBag={formikBag} />}
              {this.context && this.context.codpessoa && (
                <GetDadoNFeComponent fetchPolicy="no-cache" variables={{ values: { codpessoa: this.context.codpessoa } }}>
                  {({ data, loading }) => {
                    if (loading) {
                      return <Loading />;
                    }
                    if (data && data.getDadoNFe) {
                      return <FormDadosNFe formikBag={formikBag} data={data!} />;
                    } else {
                      return null;
                    }
                  }}
                </GetDadoNFeComponent>
              )}
              <AcoesFormulario submitCount={formikBag.submitCount}>
                <Button variant="contained" color="primary" disabled={formikBag.isSubmitting} type="submit">
                  Salvar
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={formikBag.isSubmitting}
                  type="reset"
                  onClick={() => formikBag.resetForm(initialValues)}
                >
                  Limpar
                </Button>
              </AcoesFormulario>
            </form>
          )}
        />
      </div>
    );
  }
}

const withMutation = withSalvarDadosNFe<NewEditProps>({});

export default withMutation(NewEditDadosNFe);
